import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import * as api from "../../api";
import {useFeedbackTools} from "../../components/FeedbackTools";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";


export const useMeQuery = () => {
    return useQuery({
        queryKey: ['users', 'me'],
        queryFn: api.User.me
    });
}

export const useMeMutation = () => {
    const {t} = useTranslation(["user"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();

    return useMutation({
        mutationFn: async (data) => await api.User.patchMe(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['users', 'me']);
            showSuccessNotification(t('query.accountUpdateSuccess'));
        }
    });
}

export const useUserQuery = (userId) => {
    return useQuery({
        queryKey: ['users', userId],
        queryFn: () => api.User.getUser(userId)
    });
}

export const useUserMutation = (userId, options = {}) => {
    const {t} = useTranslation(["user"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();

    return useMutation({
        mutationFn: async (data) => await api.User.patchUser(userId, data),
        onSuccess: async (data, variables, context) => {
            if (options.onSuccess) {
                await options.onSuccess(data, variables, context);
            }
            queryClient.invalidateQueries(['users']);
            showSuccessNotification(t('query.userUpdateSuccess'));
        }
    });
}

export const useUserDeleteMutation = (userId) => {
    const {t} = useTranslation(["user"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async () => await api.User.deleteUser(userId),
        onSuccess: async () => {
            await navigate('/users');
            queryClient.invalidateQueries(['users']);
            showSuccessNotification(t('query.userDeleteSuccess'));
        }
    });
}

export const useUserSettingsMutation = (userId) => {
    const {t} = useTranslation(["user"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();

    return useMutation({
        mutationFn: async (data) => await api.UserSettings.patchUserSettings(userId, data),
        onSuccess: () => {
            queryClient.invalidateQueries(['users']);
            showSuccessNotification(t('query.userSettingsUpdateSuccess'));
        }
    });

}


export const useCreateApiKeyMutation = () => {
    const {t} = useTranslation(["user"])
    const {showSuccessNotification}  = useFeedbackTools();

    return useMutation({
        mutationFn: async () => await api.User.createApiKey(),
        onSuccess: () => {
            showSuccessNotification(t('query.apiKeyCreateSuccess'));
        }
    });
}


export const useConfirmEmailMutation = () => {
    const {t} = useTranslation(["user"])
    const {showSuccessNotification}  = useFeedbackTools();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (userId) => await api.User.confirmEmail(userId),
        onSuccess: (data) => {
            showSuccessNotification(t('query.emailConfirmationSuccess'));
            queryClient.invalidateQueries(['users', `${data.id}`]);
        }
    });
}
